<template>
  <div>
    <nav class="bar bar-nav" v-if="!isWapp">
      <h1 class="title">个人信息</h1>
    </nav>
    <div class="content">
      <!--<div class="content-block-title">基本信息</div>-->
      <div class="list-block">
        <ul>
          <li class="item-content">
            <div class="item-media"><i class="icon icon-me"></i></div>
            <div class="item-inner">
              <div class="item-title">姓名</div>
              <div class="item-after">{{sessionInfo.customerInfo.customerName}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-media"><i class="icon icon-code"></i></div>
            <div class="item-inner">
              <div class="item-title">编号</div>
              <div class="item-after"><span class="badge">{{sessionInfo.customerInfo.customerNo}}</span></div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-media"><i class="icon icon-phone"></i></div>
            <div class="item-inner">
              <div class="item-title">手机</div>
              <div class="item-after">{{sessionInfo.customerInfo.mobile}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-media"><i class="icon icon-message"></i></div>
            <div class="item-inner">
              <div class="item-title">邮箱</div>
              <div class="item-after">{{sessionInfo.customerInfo.email}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-media"><i class="icon icon-code"></i></div>
            <div class="item-inner">
              <div class="item-title label">单位</div>
<!--              <div class="item-input">-->
<!--                <input class="open-popup open-enterprise" data-popup=".popup-enterprise" type="text"-->
<!--                       id="enterpriseName" v-model.trim="sessionInfo.customerInfo.enterpriseName" readonly unselectable="on">-->
<!--              </div>-->
              <div class="item-after">{{sessionInfo.customerInfo.enterpriseName}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import $ from 'jquery'
  import EMKT from '../../../emkt.js'
  
  export default {
    mounted () {
    },
    created () {
      let _this = this
      $(document).on('close', function () {
        if (_this.enterpriseInfo.enterpriseName !== undefined && _this.enterpriseInfo.enterpriseName !== null) {
          _this.sessionInfo.customerInfo.enterpriseName = _this.enterpriseInfo.enterpriseName
        }
      })
    },
    data () {
      return {
        isWapp: EMKT.isWapp
      }
    },
    computed: {
      ...mapState([
        'sessionInfo', 'enterpriseInfo'
      ])
    },
    // watch: {
    //   'enterpriseInfo': function (val) {
    //     this.gcapi('gcwwwifc/updateCustomerEnterprise', {'EnterpriseNo': val.enterpriseNo}).then((response) => {
    //       if (response.body.code === 0) {
    //         alert('单位修改成功！')
    //       } else {
    //         alert('单位修改失败，请您联系客服')
    //       }
    //     })
    //   }
    // },
    methods: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Userinfo.vue?0d59d62b